
import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { GiBattleAxe } from 'react-icons/gi';

const studyTrivia = [
  "25分勉強＋5分休憩の「ポモドーロ法」が効果的。",
  "学習後すぐの睡眠は記憶を強化する。",
  "科目を交互に学ぶと記憶が定着しやすい。",
  "音読は黙読より記憶に残りやすい。",
  "人に説明すると理解が深まる（ファインマン法）。",
  "適度な雑音（ホワイトノイズ）は集中力を高める。",
  "散歩をすると脳のデフォルトモードネットワークが活性化する。",
];

const LoadingScreen = () => {
  const [triviaIndex, setTriviaIndex] = useState(0);

  useEffect(() => {
    setTriviaIndex(Math.floor(Math.random() * studyTrivia.length));
  }, []);

  return (
    <div className="fixed inset-0 z-[200] bg-slate-50 dark:bg-slate-950 flex flex-col items-center justify-center overflow-hidden">
      {/* 背景の環境光エフェクト */}
      <div className="absolute inset-0 pointer-events-none">
        <motion.div 
          animate={{ 
            scale: [1, 1.2, 1],
            opacity: [0.3, 0.5, 0.3] 
          }}
          transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-indigo-500/10 dark:bg-indigo-500/5 blur-[120px] rounded-full"
        />
      </div>

      <div className="relative z-10 flex flex-col items-center max-w-sm w-full px-6">
        {/* メインロゴ・アニメーション */}
        <div className="relative mb-12">
          <motion.div
            animate={{ 
              scale: [1, 1.05, 1],
              rotate: [0, 5, -5, 0]
            }}
            transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
            className="relative z-10 text-indigo-600 dark:text-indigo-400"
          >
            <GiBattleAxe size={80} className="drop-shadow-[0_0_15px_rgba(79,70,229,0.4)]" />
          </motion.div>
          
          {/* 背後の魔法陣/光輪 */}
          <motion.div 
            animate={{ rotate: 360 }}
            transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
            className="absolute inset-0 -m-4 border-2 border-dashed border-indigo-200 dark:border-indigo-900/30 rounded-full opacity-50"
          />
          <motion.div 
            animate={{ rotate: -360 }}
            transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
            className="absolute inset-0 -m-8 border border-indigo-100 dark:border-indigo-800/20 rounded-full opacity-30"
          />
        </div>

        {/* 豆知識セクション */}
        <div className="text-center space-y-4">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
          >
            <span className="text-[10px] font-black uppercase tracking-[0.3em] text-indigo-500 dark:text-indigo-400 bg-indigo-50 dark:bg-indigo-900/30 px-3 py-1 rounded-full border border-indigo-100 dark:border-indigo-800/50">
              Quest Tip
            </span>
          </motion.div>
          
          <AnimatePresence mode="wait">
            <motion.p
              key={triviaIndex}
              initial={{ opacity: 0, scale: 0.98 }}
              animate={{ opacity: 1, scale: 1 }}
              className="text-slate-700 dark:text-slate-300 text-lg font-bold leading-relaxed min-h-[4rem]"
            >
              {studyTrivia[triviaIndex]}
            </motion.p>
          </AnimatePresence>
        </div>

        {/* 進捗バー */}
        <div className="w-full mt-12 bg-slate-200 dark:bg-slate-800 h-1 rounded-full overflow-hidden relative">
          <motion.div 
            initial={{ left: "-100%" }}
            animate={{ left: "100%" }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
            className="absolute top-0 bottom-0 w-1/3 bg-gradient-to-r from-transparent via-indigo-500 to-transparent"
          />
        </div>
        
        <p className="mt-4 text-[10px] font-bold text-slate-400 dark:text-slate-600 uppercase tracking-widest">
          Synchronizing with world...
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;
